import React, { useEffect } from "react";
import styles from "./accessDenied.module.scss";
import { withTranslation } from "react-i18next";
import FordLogo from "../../common/FordLogo";
import { invalidateSession } from "../../common/InvalidateSession";

const AccessDeniedAsNotOnBoarded = (props) => {
  useEffect(() => {
    props.history.push("/notonboarded");
    invalidateSession();
  }, []);

  return (
    <div className="pageWrapper">
      <div className={`pagePadding ${styles.deniedContainer}`}>
        <div className={styles.center}>
          <FordLogo className={styles.brandLogo} />
        </div>
        <div className={styles.center}>
          <div className={styles.deniedTitle}>
            {props.t("AccessDeniedAsNotOnBoarded.header")}
          </div>
        </div>
        <div className={styles.awaitingManagement}>
          {props.t("AccessDeniedAsNotOnBoarded.subheader")}
        </div>
        <div className={styles.inOrderToAccess}>
          {props.t("AccessDeniedAsNotOnBoarded.sublineOne")}
        </div>
      </div>
    </div>
  );
};

export default withTranslation("emp")(AccessDeniedAsNotOnBoarded);
